import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Empty } from 'src/components/Ant'
import { SectionHeader, TableDetail } from './components'
import { Footer, OptionsBar, TitleReport } from '..'
import { WrapPageContent, WrapPage } from '../../styles'
import { WrapTableDiv } from './styles'

const MaxRecords = 35

function R6() {
  const {
    reports: {
      reportsResources: {
        R6Data: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length && !data.length) {
      return [
        [
          <TitleReport title="web.report.6.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let index = 0

    // Make pages //
    do {
      const page: JSX.Element[] = []
      page.push(<TitleReport title="web.report.6.title" />)
      page.push(<SectionHeader />)

      const maxRecordsPossible = data.slice(index, index + MaxRecords)
      page.push(
        <WrapTableDiv>
          <TableDetail dataSource={maxRecordsPossible} />
        </WrapTableDiv>
      )
      index += MaxRecords
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R6
